/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Alert, Heading, VFlow } from 'bold-ui'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'

import { MChatMarca } from '../../objetivo/puericultura/mchat-rf/components/MChatMarca'
import { MChatRfRegistrosList } from '../../objetivo/puericultura/mchat-rf/mchat-rf-registros/MChatRfRegistrosList'
import { RegistroMChatAcompanhamentoPuericultura } from './model'

interface MChatAcompanhamentoPuericulturaProps {
  registrosMChat: RegistroMChatAcompanhamentoPuericultura[]
  cidadaoId: ID
  cidadaoDataNascimento: LocalDate
}

export function MChatAcompanhamentoPuericultura(props: Readonly<MChatAcompanhamentoPuericulturaProps>) {
  const { registrosMChat, cidadaoId, cidadaoDataNascimento } = props

  const location = useLocation<{ focusTitle?: boolean }>()
  const titleRef = useRef<HTMLHeadingElement>(null)

  useEffect(() => {
    if (location.state?.focusTitle) {
      titleRef.current?.focus()
    }
  }, [location.state])

  return (
    <VFlow vSpacing={0.5}>
      <VFlow vSpacing={0}>
        <Heading level={2}>
          M-CHAT-R/F™{' '}
          <span css={styles.innerTitle} ref={titleRef} tabIndex={-1}>
            (Checklist Modificado para Autismo em Crianças Pequenas)
          </span>
        </Heading>
        <MChatMarca />
      </VFlow>
      {registrosMChat.length > 0 && (
        <Alert type='info'>
          É possível visualizar a avaliação completa com as perguntas e respostas a partir da impressão do registro.
        </Alert>
      )}
      <MChatRfRegistrosList
        items={registrosMChat}
        cidadaoId={cidadaoId}
        cidadaoDataNascimento={cidadaoDataNascimento}
      />
    </VFlow>
  )
}

const styles = {
  innerTitle: css`
    font-weight: normal;
  `,
}
